import type {SocialAccount} from '@Components/social-media/account.vo';

export const TIKTOK_VIDEO_ACTION_ICON_PATHS: string[] = [
  'images/socialmedia/heart-icon-tiktok.svg',
  'images/socialmedia/message-icon-tiktok.svg',
  'images/socialmedia/bookmark-icon-tiktok.svg',
  'images/socialmedia/share-external-icon-tiktok.svg',
];
export const TIKTOK_VIDEO_FOLLOW_ICON_PATH = 'images/socialmedia/follow-icon-tiktok.svg';

export interface TiktokOverlayProps {
  account: SocialAccount;
  caption: string;
}
